import React from 'react';
import { connect } from 'react-redux';
import { TextAreaInput, Button } from 'b3';
import Select from 'b3/select/Select';
import { completeAndMarkAsDud } from './logActivityReducer';

@connect(
    state => ({dudReasons: state.dudReasons.dudReasons}),
    { completeAndMarkAsDud }
)
export default class MarkAsDudStep extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			closeOffNotes: '',
			closeOffReasons: [],
		};
	}
    componentDidMount() {
        this.textInput.focus();
    }
    markAsDud() {
        console.log(this.state);
        this.props.completeAndMarkAsDud(this.state);
    }
    handleSelectChange(closeOffReason) {
        var closeOffReasons = this.state.closeOffReasons.concat(closeOffReason);
        this.setState({closeOffReasons});
    }
    handleDeSelectChange(closeOffReason) {
        var closeOffReasons = this.state.closeOffReasons.filter(reason => reason.id != closeOffReason.id);
        this.setState({closeOffReasons});
    }
    render() {
        var { closeOffNotes, closeOffReasons } = this.state;
        var { dudReasons } = this.props;

        return(
            <div className="wizard-step-wrapper">
                <h1>Mark as Dud</h1>
                <div>
                    <h2>
                        Close off notes
                    </h2>
                    <TextAreaInput 
                        ref={el => this.textInput = el}
                        rows={4}
                        placeholder="Dud Reason"
                        value={closeOffNotes} 
                        onChange={closeOffNotes => this.setState({closeOffNotes})} />
                </div>
                <div style={{marginBottom: 15}}>
                    <h2>Close off reasons</h2>
                    <div style={{background: '#fff', padding: 5, borderRadius: 4, border: '1px solid #b3b3b3'}}>
                        <Select
                            canSelectMultiple={true} 
                            onOptionSelected={this.handleSelectChange.bind(this)}
                            onOptionDeselected={this.handleDeSelectChange.bind(this)}
                            selectedOptions={closeOffReasons}
                            options={dudReasons.except(closeOffReasons)}
                            template={o => o.reason}
                            placeholder="Select close off reason" />
                    </div>
                </div>

                <div className="save-and-back-or-complete-wrapper">
                    <Button type="danger" onClick={this.markAsDud.bind(this)}>Close Lead</Button>    
                </div>
                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/MarkAsDudStep.js